<div style="display: flex; flex-direction: column;">
    <h1 style="display: flex; justify-content: center;"><span>Page not found. Please click <a [routerLink]="['/home']">here</a> to return home</span></h1>
</div>
